import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Convert a Browser Blob object into ArrayBuffer.
 *
 * @param blob -
 */
export function blobToArrayBuffer(_x) {
  return _blobToArrayBuffer.apply(this, arguments);
}
/**
 * Convert a Browser Blob object into string.
 *
 * @param blob -
 */

function _blobToArrayBuffer() {
  _blobToArrayBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob) {
    var fileReader;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileReader = new FileReader();
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              fileReader.onloadend = function (ev) {
                resolve(ev.target.result);
              };

              fileReader.onerror = reject;
              fileReader.readAsArrayBuffer(blob);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _blobToArrayBuffer.apply(this, arguments);
}

export function blobToString(_x2) {
  return _blobToString.apply(this, arguments);
}

function _blobToString() {
  _blobToString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blob) {
    var fileReader;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fileReader = new FileReader();
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              fileReader.onloadend = function (ev) {
                resolve(ev.target.result);
              };

              fileReader.onerror = reject;
              fileReader.readAsText(blob);
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _blobToString.apply(this, arguments);
}

export function streamToBuffer() {
  /* empty */
}
export function streamToBuffer2() {
  /* empty */
}
export function readStreamToLocalFile() {
  /* empty */
}
export var fsStat = function stat() {
  /* empty */
};
export var fsCreateReadStream = function createReadStream() {
  /* empty */
};